(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Modal } from "./";
import { Flex } from "../layout";
import { Button } from "../buttons";
import { Paragraph } from "../text";
var ModalActions = styled(Button).withConfig({
  displayName: "ConfirmationDialog__ModalActions",
  componentId: "sc-qr2fhl-0"
})(["flex:1 0 0;"]);
var ModalMessage = styled(Paragraph).withConfig({
  displayName: "ConfirmationDialog__ModalMessage",
  componentId: "sc-qr2fhl-1"
})(["text-align:center;"]);

var ConfirmationDialog = function ConfirmationDialog(props) {
  var buttonDismiss = props.buttonDismiss,
      buttonCancel = props.buttonCancel,
      buttonConfirm = props.buttonConfirm,
      open = props.open,
      title = props.title,
      variant = props.variant,
      message = props.message,
      onSubmit = props.onSubmit,
      onClose = props.onClose;
  return React.createElement(Modal, {
    open: open,
    heading: title,
    size: "sm"
  }, React.createElement(Flex, {
    marginBottom: "16px"
  }, React.createElement(ModalMessage, null, message)), React.createElement(Flex, null, variant === 'confirm' && React.createElement(Fragment, null, React.createElement(ModalActions, {
    color: "secondary",
    onClick: onClose,
    size: "sm"
  }, buttonCancel), React.createElement(ModalActions, {
    color: "primary",
    onClick: onSubmit,
    size: "sm"
  }, buttonConfirm)), variant === 'info' && React.createElement(ModalActions, {
    color: "primary",
    onClick: onSubmit,
    size: "sm"
  }, buttonDismiss)));
};

ConfirmationDialog.propTypes = {
  variant: PropTypes.oneOf(['confirm', 'info'])
};
ConfirmationDialog.defaultProps = {
  variant: 'confirm',
  buttonConfirm: 'Yes',
  buttonCancel: 'No',
  buttonDismiss: 'OK'
};
var _default = ConfirmationDialog;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ModalActions, "ModalActions", "/home/vsts/work/1/s/src/components/overlays/ConfirmationDialog.js");
  reactHotLoader.register(ModalMessage, "ModalMessage", "/home/vsts/work/1/s/src/components/overlays/ConfirmationDialog.js");
  reactHotLoader.register(ConfirmationDialog, "ConfirmationDialog", "/home/vsts/work/1/s/src/components/overlays/ConfirmationDialog.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/overlays/ConfirmationDialog.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();